import React, { useEffect } from 'react';
// import ReactGA from 'react-ga4';

const Step8 = ({ formData, handleInputChange, setStep }) => {
  useEffect(() => {
    // const pageName = 'Step8';
    // ReactGA.event({
    //   category: 'Navigation',
    //   action: 'Page View',
    //   page_name: pageName
    // });
    sessionStorage.setItem('lastPage', 'Step8');
  }, []);

  const handleFormSubmit = (answer) => {
    handleInputChange({ target: { name: 'glucocorticoids', value: answer === 'yes' } });
    setStep(10);
  };

  return (
    <div className="p-4 bg-blue-100 rounded-lg">
      <h2 className="common-title mb-4">ステップ 8</h2>
      <p className="text-base mb-4 text-lg">ステロイドの飲み薬を使用していますか？または、使用していたことがありますか？<br /><br />
        <span className="underline-wavy text-red-500">※不明な場合は、「いいえ」を選んでください。</span>
      </p>
      <p className="text-regular text-lg mb-2">※以下にあてはまる場合は、「はい」を選んでください。</p>
      <ul className="text-regular text-lg list-disc list-inside mb-5">
        <li>現在、ステロイドの飲み薬を使用している</li>
        <li>過去に3ヶ月以上、ステロイドの飲み薬(プレドニゾロン5mg以上に相当)を使用していた</li>
      </ul>
      <br />
      <div className="flex justify-between">
        <button 
          onClick={() => setStep(8)} 
          className="bg-gray-500 text-white p-2 rounded hover:bg-gray-600 w-auto"
        >
          前の画面へもどる
        </button>
        <button 
          onClick={() => handleFormSubmit('yes')} 
          className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600 w-auto"
        >
          はい
        </button>
        <button 
          onClick={() => handleFormSubmit('no')} 
          className="bg-pink-500 text-white p-2 rounded hover:bg-pink-600 w-auto"
        >
          いいえ
        </button>
      </div>
    </div>
  );
};

export default Step8; 